import { useState } from 'react';

import { usePreAuthFinePrint } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { PaymentForm } from 'reservations/payments/components/PaymentForm';

export const AddCardToEnrollModal = () => {
  const [handleSaveCard, setHandleSaveCard] = useState<() => void>(() => {});
  const { open } = useModal();

  const handleClick = async () => {
    await handleSaveCard?.();
    open(ModalType.SelectGratuity);
  };

  return (
    <BaseDrawer
      header="Add your card to enroll"
      primaryButton={{ label: 'NEXT', onClick: handleClick }}
      footer={usePreAuthFinePrint()}
      requireAuth
    >
      <PaymentForm setHandleSaveCard={setHandleSaveCard} />
    </BaseDrawer>
  );
};
